import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import Alert from "../common/Alert";
import {
  NOTES_SAVED_SUCCESSFULLY,
  ERROR_FETCHING_STAFF_NOTES,
  ERROR_SAVING_STAFF_NOTES,
  EMPTY_NOTE,
} from "../../configurations/MessageConstants";
import SuperUserService from "../../api-service/SuperUserService";
import { ThreeDots } from "react-loader-spinner";
import RichTextEditor from "./RichTextEditor";
import SessionHelper from "../../helpers/SessionHelper";
import DashboardHelper from "../../helpers/DashboardHelper";
import { DANGER, EMPTY, INFO } from "../../configurations/Constants";
import { StatusCodes } from "../../configurations/status-codes";

function TabNotes(props) {
  const [staffNotes, setStaffNotes] = useState(EMPTY);
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [variant, setVariant] = useState(EMPTY);
  const [showAlert, setShowAlert] = useState(false);
  const [sendBtnClick, setSendBtnClick] = useState(false);

  useEffect(() => {
    getStaffNotesForField();
  }, []);

  const getStaffNotesForField = async () => {
    try {
      setLoadingNotes(true);
      let fieldId = props.fieldDetails.field_id
        ? props.fieldDetails.field_id
        : props.fieldDetails.user_field_id;

      const response = await SuperUserService.getStaffNotesForField(fieldId);
      setStaffNotes(response.data.data.note);
      setLoadingNotes(false);
    } catch (error) {
      console.error(ERROR_FETCHING_STAFF_NOTES, error);
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        setLoadingNotes(false);
        setAlertMessage(ERROR_FETCHING_STAFF_NOTES);
        setVariant(DANGER);
        setShowAlert(true);
      }
    }
  };

  const handleCloseAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setShowAlert(false);
  };

  const handleCloseNotes = (e) => {
    handleCloseAlert();
    props.handleCloseModel(e);
  };

  const handleSubmitNotes = async () => {
    setSendBtnClick(true);
    await SessionHelper.handleRefreshToken();

    try {
      let finalValue = staffNotes;
      let finalValueWithLineBreaks = finalValue.replaceAll(/<br>/gi, "\n");
      let finalValueWithoutHtml = DashboardHelper.stripHtml(
        finalValueWithLineBreaks
      );
      if (finalValueWithoutHtml.trim().length === 0) {
        setAlertMessage(EMPTY_NOTE);
        setVariant(DANGER);
        setShowAlert(true);
        setSendBtnClick(false);
        return;
      }
      let payload = {
        note: finalValueWithoutHtml,
        note_html: `<div style="font-family:arial,sans-serif; font-size:13px; color:gray;">${finalValue}</div>`,
      };
      let fieldId = props.fieldDetails.field_id
        ? props.fieldDetails.field_id
        : props.fieldDetails.user_field_id;

      await SuperUserService.updateFieldStaffNotes(fieldId, payload);
      setAlertMessage(NOTES_SAVED_SUCCESSFULLY);
      setVariant(INFO);
      setShowAlert(true);
      setSendBtnClick(false);
    } catch (error) {
      setAlertMessage(ERROR_SAVING_STAFF_NOTES);
      setVariant(DANGER);
      setShowAlert(true);
      setSendBtnClick(false);
    }
  };

  return (
    <div className="notes">
      {loadingNotes ? (
        <div className="text-center">
          <ThreeDots color="#00BFFF" height={80} width={80} />
        </div>
      ) : (
        <div>
          {showAlert && (
            <Alert
              key="messageAlert"
              variant={variant}
              closeAlert={(e) => handleCloseAlert(e)}
              alertMessage={alertMessage}
              dismissible
            />
          )}
          <h5 className="notes-label mt-4">Enter your notes here :</h5>
          <RichTextEditor
            displayString={staffNotes}
            setDisplayString={setStaffNotes}
          />
          <h6 className="mt-4">
            NOTE: These notes are available only for the Twin Platte NRD
            authorized personnel to view
          </h6>
          <Button
            variant="primary"
            type="submit"
            onClick={handleSubmitNotes}
            className="notes-send"
            disabled={sendBtnClick ? true : false}
          >
            {sendBtnClick === true ? (
              <div>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                <span>{"Saving..."}</span>
              </div>
            ) : (
              "Save"
            )}
          </Button>
          <Button
            variant="primary"
            type="submit"
            className="notes-close"
            onClick={(e) => handleCloseNotes(e)}
          >
            Close
          </Button>
        </div>
      )}
    </div>
  );
}

export default TabNotes;
